import { keyValueObject } from '../lib/types'

export const formatVariables = (
  dataKey: string | null,
  variableObject: keyValueObject
): keyValueObject => {
  const updatedVariables =
    dataKey !== null
      ? { [dataKey]: { ...variableObject } }
      : { ...variableObject }
  return updatedVariables as keyValueObject
}
